// @flow
import itemsRemoved from 'app/common/redux/actions/feeds/itemsRemoved';
import type { Thunk } from 'app/common/redux/types';
import { FEED_TYPE } from 'app/common/redux/reducers/feeds';

export type AggregatedCommentHidden = {
  type: 'AGGREGATED_COMMENT_HIDDEN',
  payload: {
    aggregatedCommentId: string,
  },
};

export function aggregatedCommentHidden(aggregatedCommentId: string): AggregatedCommentHidden {
  return {
    type: 'AGGREGATED_COMMENT_HIDDEN',
    payload: {
      aggregatedCommentId,
    },
  };
}

export type AggregatedCommentHideData = {
  aggregatedCommentId: string,
  parentId: string,
};

export function hideAggregatedComment({
  aggregatedCommentId,
  parentId,
}: AggregatedCommentHideData): Thunk<void> {
  return (dispatch) => {
    // TODO(Danay): consider refactoring Flag component and putting resource call here
    dispatch(aggregatedCommentHidden(aggregatedCommentId));
    dispatch(
      itemsRemoved({
        feedId: parentId,
        feedType: FEED_TYPE.AGGREGATED_COMMENTS,
        itemIds: [aggregatedCommentId],
        itemType: 'aggregatedcomment',
      }),
    );
  };
}
